import moment from 'moment-timezone';

/**
 * 将时间格式化为东八区时间
 * @param {string|Date|moment} time - 需要格式化的时间
 * @param {string} format - 格式化字符串，默认为 'YYYY-MM-DD HH:mm:ss'
 * @returns {string} 格式化后的时间字符串
 */
export const formatBeijingTime = (time, format = 'YYYY-MM-DD HH:mm:ss') => {
  if (!time) return '';
  
  // 使用moment-timezone将时间转换为东八区时间并格式化
  return moment(time).tz('Asia/Shanghai').format(format);
};

/**
 * 获取当前东八区时间
 * @param {string} format - 格式化字符串，默认为 'YYYY-MM-DD HH:mm:ss'
 * @returns {string} 格式化后的当前东八区时间
 */
export const getCurrentBeijingTime = (format = 'YYYY-MM-DD HH:mm:ss') => {
  return moment().tz('Asia/Shanghai').format(format);
};

export default {
  formatBeijingTime,
  getCurrentBeijingTime
};